import { useAccountRateFieldApi } from '../api';

export const useAccountRatesTAccBondsCourtMin = () => {
  const result = useAccountRateFieldApi({
    field: 'T_ACC.BONDS_COURT_MIN',
  });
  return result;
};
